var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336.41 337.42"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".BUSD_svg__cls-1{fill:#f0b90b;stroke:#f0b90b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BUSD_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BUSD_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSD_svg__cls-1",
    d: "M168.2.71l41.5 42.5-104.5 104.5-41.5-41.5zM231.2 63.71l41.5 42.5-167.5 167.5-41.5-41.5zM42.2 126.71l41.5 42.5-41.5 41.5-41.5-41.5zM294.2 126.71l41.5 42.5-167.5 167.5-41.5-41.5z"
  })))));
}
export default SvgBusd;